import React from "react";
import AdPanelList from "../components/AdPanelList";
import PanelLayout from "../components/PanelLayout";
import PanelAdsHeader, { renderPanelTabLabel } from "../components/PanelAdsHeader";
import AdListSkeleton from "../components/AdListSkeleton";
import { connect } from "react-redux";
import * as actions_active from "../redux/actions/adAuctionActions";
import * as actions_inactive from "../redux/actions/adAuctionInactiveActions";
import Tabs from "../components/Tabs";
import "./styles/PanelAds.css";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

class AdAuction extends React.Component {
  componentDidMount() {
    this.fetchAdAuctionList();
  }

  fetchAdAuctionList = async () => {
    try {
      await this.props
        .LoadPublish(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
      await this.props
        .LoadPublishI(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.errori) {
            alertify.warning(I18n.t(this.props.errori));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadPublishMore(
          this.props.pageCount,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickLoadMoreI = async () => {
    try {
      await this.props
        .LoadPublishMoreI(
          this.props.pageCounti,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.errori) {
            alertify.warning(I18n.t(this.props.errori));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { activeCount, inactiveCount } = this.props;

    return (
      <PanelLayout>
        <div className="panel-ads-page">
          <PanelAdsHeader
            title={<Translate value="auction" />}
            newTo="/goder/new/auction"
          />

          <div className="panel-ads-page__tabs">
            <Tabs>
              <div
                tabKey="active"
                label={renderPanelTabLabel(I18n.t("ad_active"), activeCount)}
                className="col-12"
              >
                {this.props.loading ? (
                  <AdListSkeleton count={6} />
                ) : (
                  <AdPanelList
                    adPanelList={this.props.adListActive || []}
                    pageSize={this.props.pageSize}
                    loadingMore={this.props.loadingMore}
                    pageCount={this.props.pageCount}
                    onClickLoadMore={this.onClickLoadMore}
                  />
                )}
              </div>
              <div
                tabKey="inactive"
                label={renderPanelTabLabel(
                  I18n.t("ad_inactive"),
                  inactiveCount
                )}
                className="col-12"
              >
                {this.props.loading_inactive ? (
                  <AdListSkeleton count={6} />
                ) : (
                  <AdPanelList
                    adPanelList={this.props.adListInactive || []}
                    pageSize={this.props.pageSizei}
                    loadingMore={this.props.loadingMorei}
                    pageCount={this.props.pageCounti}
                    isInactiveTab
                    onClickLoadMore={this.onClickLoadMoreI}
                  />
                )}
              </div>
            </Tabs>
          </div>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  const adListActive = reducer.adAuction.list || [];
  const adListInactive = reducer.adAuctionInactive.list || [];

  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    adListActive,
    error: reducer.adAuction.error,
    loading: reducer.adAuction.loading,
    loadingMore: reducer.adAuction.loadingMore,
    pageCount: reducer.adAuction.page_count,
    pageSize: reducer.adAuction.page_size,
    adListInactive,
    loading_inactive: reducer.adAuctionInactive.loading,
    errori: reducer.adAuctionInactive.error,
    loadingMorei: reducer.adAuctionInactive.loadingMore,
    pageCounti: reducer.adAuctionInactive.page_count,
    pageSizei: reducer.adAuctionInactive.page_size,
    activeCount: adListActive.length,
    inactiveCount: adListInactive.length,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadPublish: (user_id, token) =>
    dispatch(actions_active.loadList({ user_id, token })),
  LoadPublishMore: (page_count, user_id, token) =>
    dispatch(actions_active.loadListScroll({ page_count, user_id, token })),
  LoadPublishI: (user_id, token) =>
    dispatch(actions_inactive.loadList({ user_id, token })),
  LoadPublishMoreI: (page_count, user_id, token) =>
    dispatch(actions_inactive.loadListScroll({ page_count, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdAuction);
